import { Injectable } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class PosthogService {
  private get initialized(): boolean {
    return !!environment.posthog.apiKey && environment.posthog.apiKey !== 'phc_PLACEHOLDER';
  }

  capture(event: string, properties?: Record<string, unknown>): void {
    if (!this.initialized) return;
    posthog.capture(event, properties);
  }

  identify(distinctId: string, properties?: Record<string, unknown>): void {
    if (!this.initialized) return;
    posthog.identify(distinctId, properties);
  }

  reset(): void {
    if (!this.initialized) return;
    posthog.reset();
  }
}
